import VaultAbi from '@/lib/abi/Vault.json';

import { getMulticaller } from '@/dependencies/Multicaller';
import { difference } from 'lodash';
import { networkConfig } from '@/composables/useNetwork';

export default function useVaultPoolData({
  vaultAddress,
  fields = ['totalAssets', 'totalSupply', 'totalInvestmentValue'],
}: {
  vaultAddress: Ref<string | undefined>;
  fields?: ['totalAssets', 'totalSupply', 'totalInvestmentValue'];
}) {
  const vaultPoolData = ref({
    totalAssets: 0,
    totalSupply: 0,
    totalInvestmentValue: 0,
  });
  const called = ref(false);
  const loading = ref(false);

  const needExecute = executeFields => {
    return difference(executeFields, fields).length === 0;
  };

  watchEffect(() => {
    if (!vaultAddress.value) return;
    if (!called.value) {
      loading.value = true;
      called.value = true;

      (async () => {
        const Multicaller = getMulticaller();
        const multicaller = new Multicaller();

        if (vaultAddress.value) {
          try {
            needExecute(['totalAssets']) &&
              multicaller.call({
                key: 'totalAssets',
                address: vaultAddress.value,
                function: 'totalAssets',
                abi: VaultAbi,
                params: [],
              });

            needExecute(['totalSupply']) &&
              multicaller.call({
                key: 'totalSupply',
                address: vaultAddress.value,
                function: 'totalSupply',
                abi: VaultAbi,
                params: [],
              });
            needExecute(['totalInvestmentValue']) &&
              multicaller.call({
                key: 'totalInvestmentValue',
                address: vaultAddress.value,
                function: 'getVaultBalance',
                abi: VaultAbi,
                params: [],
              });
          } catch (e) {
            console.log('pool data failure', { e });
          }
        }

        const poolInfo = await multicaller.execute();
        vaultPoolData.value = {
          totalAssets: poolInfo.totalAssets || 0,
          totalSupply: poolInfo.totalSupply || 0,
          totalInvestmentValue: poolInfo.totalInvestmentValue || undefined,
        };
        loading.value = false;
      })();
    }
  });

  return { vaultPoolData, loading };
}
